let timeout: NodeJS.Timer | null = null;
export const useDebounceFunc = (milliSeconds: number = 200) => {
    const debounce = (fn: () => void) => {
        timeout && clearTimeout(timeout);
        timeout = setTimeout(() => {
            fn();
        }, milliSeconds);
    };

    return debounce;
};
